import { CustomerChannel } from "@/services/customer-channel.ts";
import { Formatter } from "@/services/formatter.ts";
import { Customer } from "@/context/customer.ts";
import { Services } from "@/services/services.ts";
import { CustomerChannelAvailableCountriesDocument } from "@/generated/graphql/b2c";
import { Context } from "@/services/context.ts";

export const defaultCountryCode = "LV";
export const COUNTRIES_LISTENER_NAME = "countries";

export class Countries {
  protected currentCountryCode: string | undefined;
  public allCountriesIsLoaded = false;
  private isLoadingState = false;

  constructor(
    protected context: Context,
    protected customerChannel: CustomerChannel,
    protected formatter: Formatter,
    protected customer: Customer,
    protected services: Services,
  ) {
    if (!import.meta.env.SSR) {
      window.addEventListener("route:load-end", () => this.fetchAllCountries());
    }
  }

  getCurrentCountryCode() {
    return this.currentCountryCode ?? defaultCountryCode.toLowerCase();
  }

  getCurrentCountry() {
    return this.getChannelCountries()?.find((item) => item.code === this.currentCountryCode);
  }

  getByCode(code: string) {
    const normalizedCode = code.toUpperCase();
    return this.getChannelCountries()?.find((item) => item.code === normalizedCode);
  }

  getChannelCountries() {
    return this.customerChannel?.availableCountries;
  }

  async fetchAllCountries() {
    if (this.allCountriesIsLoaded || this.isLoadingState) {
      return;
    }
    this.isLoadingState = true;
    const response = await this.services.api.client.query({
      query: CustomerChannelAvailableCountriesDocument,
    });
    this.customerChannel.availableCountries = response!.data.CustomerChannel.availableCountries;

    this.context.notify(COUNTRIES_LISTENER_NAME);
    this.isLoadingState = false;
    this.allCountriesIsLoaded = true;
  }
}
